import { tableHeaderExtension as tableHeaderExtensionBase } from '@copera/tiptap/extensions';

export const tableHeaderExtension = tableHeaderExtensionBase.extend({
  allowGapCursor: false,
});
